module.exports = __webpack_public_path__ + "font_kacho_son.1c4f270c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_kacho_son.png
// module id = CQUD
// module chunks = 0